<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      :is-downloading="isDownloading"
      :export-options="['csv', 'pdf']"
      @isExport="onExport"
      @filterOption="onFiltersChange"
    >
      <template v-slot:charge_point_id="{ item }">
        <div
          class="d-flex align-center open-link"
          @click="openHistory(item)"
        >
          {{ item.charge_point_id }}
        </div>
      </template>
      <template v-slot:severity_level="{ item }">
        <div class="d-flex align-center">
          <StatusBadge
            :status="item.severity_level"
            :text="item.severity_level"
          />
        </div>
      </template>

      <template v-slot:status="{ item }">
        <div class="d-flex align-center">
          <StatusBadge
            :status="item.status"
            :text="item.status"
          />
        </div>
      </template>
      <template v-slot:closing_status="{ item }">
        <div
          v-if="item.actual_closing_time && item.expected_closing_time"
          class="d-flex align-center"
        >
          <StatusBadge
            :status="
              item.actual_closing_time > item.expected_closing_time
                ? 'late'
                : 'on_time'
            "
            :text="
              item.actual_closing_time > item.expected_closing_time
                ? 'late'
                : 'on_time'
            "
          />
        </div>
      </template>

      <template v-slot:updated_at="{ item }">
        <div>
          {{ item.updated_at | formatDate }}
        </div>
      </template>

      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <template #description>
        <slot />
      </template>
      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-ticket
            v-if="isCreate && showCreate"
            :filter-options="options"
          />

          <edit-ticket
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
          <Modal
            :is-visible="isHistoryModal"
            is-view
            width="650px"
            title="Ticket Status History"
            :toggle="() => (isHistoryModal = false)"
          >
            <div class="my-2 d-flex flex-wrap gap5">
              <span class="font-weight-bold">Notes:</span>
              <p>{{ selectedRow?.notes }}</p>
            </div>

            <v-timeline
              align-top
              dense
            >
              <v-timeline-item
                v-for="(val, i) in selectedHistory"
                :key="i"
                :color="getColor(val.status)"
                small
              >
                <v-row class="pt-1">
                  <v-col cols="6">
                    <strong class="text-capitalize">{{ val?.status }}</strong>
                  </v-col>
                  <v-col>
                    <strong>{{ val?.created_at | formatDate }}</strong>
                    <!-- <div class="text-caption">
                Mobile App
              </div> -->
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </Modal>
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
// import moment from "moment";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateTicket: () => import("./dialogs/CreateTicket.vue"),
    EditTicket: () => import("./dialogs/EditTicket.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
    // CopyContent: () => import("@/components/base/CopyContent.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    refreshButton: () =>
      import("../../../../components/base/RefreshButton.vue"),

    Modal: () => import("@/components/Modals/Modal.vue"),
  },
  mixins: [ListingLayoutMixins],
  props: {
    showCreate: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },

  data() {
    return {
      isHistoryModal: false,
      selectedHistory: {},
      //
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "ticket-management-and-reports.view",
        create: "ticket-management-and-reports.create",
        edit: "ticket-management-and-reports.edit",
        delete: "ticket-management-and-reports.delete",
      },
      filters: {},
      subFilters: {},
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "ticketManagement/getLoading",
      meta: "ticketManagement/getMeta",
      list: "ticketManagement/getList",
      isDownloading: "ticketManagement/getDownloading",
      //
      integrationInfo: "csmsChargeStations/getIntegrationInfo",
      integrationLoading: "csmsChargeStations/getIntegrationLoading",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: true,
          value: "charge_point_id",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Severity",
          align: "left",
          sortable: true,
          value: "severity_level",
        },
        {
          text: this.$t("notes"),
          align: "left",
          sortable: false,
          value: "notes",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "status",
        },
        {
          text: this.$t("closing_status"),
          align: "left",
          sortable: false,
          value: "closing_status",
        },
        {
          text: this.$t("remaining_time"),
          align: "left",
          sortable: true,
          value: "remaining_time",
        },
        {
          text: this.$t("reports"),
          align: "left",
          sortable: false,
          value: "reports",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search", "locations", "charge_point"];
    },
    copyText() {
      return (
        "Charge Station OCPP ID: " +
        this.integrationInfo.charge_point_id +
        "  OCPP Connection URL:  " +
        this.integrationInfo.ocpp_connection_url
      );
    },
  },
  watch: {
    options(v) {
      this.$emit("change", v);
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    // clearTimeout(this.interval);
    const params = {
      name: "ticket_management_and_reports",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    isNotEmpty(obj) {
      return obj && Object.keys(obj).length > 0;
    },
    openHistory(item) {
      this.selectedHistory = {};
      this.selectedRow = item;
      this.$store
        .dispatch("ticketManagement/history", { id: item.id })
        .then((data) => {
          this.selectedHistory = data;
          this.isHistoryModal = true;
        });
    },
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("ticketManagement/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    getColor(val) {
      if (val == "opened") {
        return "blue";
      } else if (val == "acknowledged") {
        return "yellow";
      } else if (val == "closed") {
        return "green";
      } else if (val == "restored") {
        return "pink";
      }
    },

    async onExport(val) {
      const params = { ...this.options, export_format: val };
      await this.$store
        .dispatch("ticketManagement/export", params)
        .then((res) => {
          window.open(res[val], "_blank");
        });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("ticketManagement/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
